// extracted by mini-css-extract-plugin
module.exports = {"smartInput":"_6Ww0cC"};